module.exports = __webpack_public_path__ + "img/seal1.3d401e2b.png";